<template>
  <div>
    <div class="columns">
      <div class="column is-3">
    
              <p class="subtitle" v-if="cities">Hotels <strong>({{cities.length}}) </strong></p>
     <div class="box">  <a class="button is-primary full-width-button mb-1" @click="openAddCityDialog">
          <span class="icon is-small">
            <i class="fas fa-plus"></i>
          </span>
          <span>Add Hotel</span>
        </a>
        <b-field expanded>
              <b-input v-model="searchName"  type="search" icon="search" :disabled="!cities || !cities.length" placeholder="Search Hotels "></b-input>
            </b-field>
        <p v-if="isLoading">Loading Hotels...</p>
        <div class="city-sidebar" v-if="!isLoading">
          <div v-for="city in filterBy(cities, searchName)" :key="city.docId" class="card" :class="{'is-active': isCitySelected(city)}">
            <div class="card-content">
              <div class="city-container">
               <!--  <div v-if="city">
                <div v-if="city.configs.active == true" style="color:#00cc00;">&#9679;</div>
                <div v-else style="color:red;">&#9679;</div></div> -->
                <p>{{city.name}}</p>
               
          <b-tooltip label="Double Click"
            position="is-right"
            animated>
                <div>
                  <a class="button is-small " @click="changeCitySelected(city)">
                    <span class="icon is-small">
                      <i class="fas fa-arrow-right" style="color:white;"></i>
                    </span>
                  </a>
                </div>  </b-tooltip>
              </div>
            </div>
          </div>
        </div>
      </div> </div> 
      <div class="column">
        <p class="subtitle" v-if="!citySelected">No Hotel selected</p>
        <p v-if="!citySelected">Please select a hotel.</p>
          <b-field grouped>
        <p class="subtitle" v-if="citySelected"><strong>{{citySelected.name}}</strong>, {{citySelected.configs.location}}&nbsp; &nbsp;</p>
        <div v-if="citySelected"> <span class="tag is-success " v-if="citySelected.configs.active == true"> Online</span>
          <div class="tag is-danger" v-else>Offline</div> </div> </b-field>
        <div  v-if="citySelected">
          <div class="box">
            <b-tabs type="is-boxed" expanded v-model="activeTab">
              <b-tab-item label="Analytics">
                <analytics :city="citySelected" />
              </b-tab-item>

              <b-tab-item label="Information">
                <information :city="citySelected" />
              </b-tab-item>
              <b-tab-item label="Contact">
                <contact :city="citySelected" />
              </b-tab-item>

              <b-tab-item label="Seasons">
                <seasons :city="citySelected" />
              </b-tab-item>

              <b-tab-item label="Rooms">
                <rooms :city="citySelected" />
              </b-tab-item>

             <!--  <b-tab-item label="Zipcodes">
                <zipcodes :city="citySelected" />
              </b-tab-item> -->

              <!-- <b-tab-item label="Products">
                <products :city="citySelected" />
              </b-tab-item> -->
              
              <b-tab-item label="Photos">
                <banners :city="citySelected" />
              </b-tab-item>

         <!--      <b-tab-item label="Offers">
                <offers :city="citySelected" />
              </b-tab-item> -->
<!-- 
              <b-tab-item label="Orders">
                <orders :city="citySelected" />
              </b-tab-item> -->
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Analytics from './Analytics/Analytics';
import Information from './Information/Information';
import Contact from './Contact/Contact';
import Seasons from './Seasons/Seasons';
import Rooms from './Rooms/Rooms';
import Zipcodes from './Zipcodes/Zipcodes';
import Products from './Products/Products';
import Orders from './Orders/Orders';
import Banners from './Banners/Banners';
import Offers from './Offers/Offers';
import CityService from './service';

export default {
  name: 'hotel',

  components: {
    Analytics,
    Information,
    Contact,
    Seasons,
    Rooms,
    Zipcodes,
    Products,
    Orders,
    Banners,
    Offers
  },

  created() {
    this.fetchCities();
  },

  data() {
    return {
      activeTab: 0,
      configs : {
          active : ''
      },
      isLoading: true,
      cities: [],
      citySelected: null,
      searchName: null,
    };
  },

  methods: {
    fetchCities() {
      CityService.all().then(cities => {
        this.cities = cities;
        this.isLoading = false;
      });
    },

    isCitySelected(city) {
      return this.citySelected && this.citySelected.docId === city.docId;
    },

    changeCitySelected(city) {
      this.citySelected = city;
      this.$bus.$emit('CITY_CHANGED', city);
      this.$toast.open('Current hotel updated');
    },

    openAddCityDialog() {
      this.$dialog.prompt({
        message: `Enter hotel name`,
        inputAttrs: {
          placeholder: 'e.g. Hotel Taj'
        },
        onConfirm: value => {
          this.isLoading = true;

          CityService.add(value).then(response => {
            const newCity = {
              docId: response.id,
              name: value
            };

            this.cities.push(newCity);
            this.isLoading = false;
            this.$toast.open({
                    message: 'Hotel Added Successfully',
                    type: 'is-success'
                });
          });
        }
      });
    }
  }
};
</script>

<style scoped>
.city-container {
  height: 100%;
  display: flex;
  justify-content: space-between;
}
.card-content {
  padding: 0.75rem;
}
</style>




// WEBPACK FOOTER //
// src/pages/hotel/Cities.vue